module.exports = __webpack_public_path__ + "static/img/25.3ab827a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/25.jpg
// module id = Wb9S
// module chunks = 16